import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import UserHeaderBar from "../../components/userHeaderBar/userHeaderBar";
import styles from "../../publicAsset/userSettingPage.module.scss";
import UserInfoHolder from "../../components/userInforHolder/userInforHolder";
import UserInvitationHolder from "../../components/userInvitationHolder/userInvitationHolder";
import UserBillingHolder from "../../components/userBillingHolder/userBIllingHolder";
import PaymentSuccessModal from "../../components/paymentSuccessModal/PaymentSuccessModal";
import { isFeatureEnabled, FEATURES } from "../../utils/featureFlags";

const PAYMENT_SUCCESS_STORAGE_KEY = 'prepal_payment_success';

const UserSetting = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [showPaymentSuccessModal, setShowPaymentSuccessModal] = useState(false);
    const [paymentSuccessData, setPaymentSuccessData] = useState(null);

    const hasPaymentSuccessFlag = useMemo(() => {
        const params = new URLSearchParams(location.search);
        return params.get('payment') === 'success';
    }, [location.search]);

    useEffect(() => {
        if (!hasPaymentSuccessFlag) {
            return;
        }

        const storedValue = sessionStorage.getItem(PAYMENT_SUCCESS_STORAGE_KEY);
        const params = new URLSearchParams(location.search);
        const fallbackPaymentData = {
            transactionId: params.get('_ptxn') || null,
            packageId: params.get('packageId') || null,
            packageName: params.get('packageName') || null,
            completedAt: new Date().toISOString(),
        };

        if (!storedValue) {
            setPaymentSuccessData(fallbackPaymentData);
            setShowPaymentSuccessModal(true);
            return;
        }

        try {
            const parsedValue = JSON.parse(storedValue);
            setPaymentSuccessData(parsedValue);
            setShowPaymentSuccessModal(true);
        } catch (error) {
            sessionStorage.removeItem(PAYMENT_SUCCESS_STORAGE_KEY);
            setPaymentSuccessData(fallbackPaymentData);
            setShowPaymentSuccessModal(true);
        }
    }, [hasPaymentSuccessFlag, location.search]);

    const handleClosePaymentSuccessModal = () => {
        setShowPaymentSuccessModal(false);
        setPaymentSuccessData(null);
        sessionStorage.removeItem(PAYMENT_SUCCESS_STORAGE_KEY);

        if (hasPaymentSuccessFlag) {
            navigate('/user-setting', { replace: true });
        }
    };

    return (
        <>
            <Helmet>
                <title>User Settings | Prepal</title>
                <meta name="description" content="User Settings for Prepal account holders." />
                <meta name="keywords" content="Prepal, user settings, education" />
                <meta name="author" content="Prepal Team" />
            </Helmet>
            <div className={styles.userSettingPage}>
                <PaymentSuccessModal
                    open={showPaymentSuccessModal}
                    packageName={paymentSuccessData?.packageName}
                    onClose={handleClosePaymentSuccessModal}
                />
                <UserHeaderBar />
                <div className={styles.userInfoHolder}>
                    <UserInfoHolder />
                </div>
                <div className={styles.userBillingHolderAndInvitationHolder}>
                    {isFeatureEnabled(FEATURES.INVITATION) && <UserInvitationHolder />}
                    <UserBillingHolder />
                </div>
            </div>
        </>
    );
};

export default UserSetting;
